<template>
  <div class="header-layer">
    <div class="logo-layer">{{ projectData.title }}</div>
    <div class="center-layer">
      <div class="nav">
        <button class="btn" @click="NavJump('/home')"
                :class="$route.path == '/home' ? 'txt-blue' : 'txt-black'">首页</button>
        <button class="btn" @click="NavJump('/case')"
                :class="$route.path == '/case' ? 'txt-blue' : 'txt-black'">案例中心</button>
        <button class="btn" @click="NavJump('/sceneExperience')"
                :class="$route.path == '/sceneExperience' ? 'txt-blue' : 'txt-black'">场景体验</button>
        <button class="btn" @click="NavJump('/curriculum')"
                :class="$route.path == '/curriculum' ? 'txt-blue' : 'txt-black'">理论学习</button>
        <!-- <button class="btn" @click="Jump('/theoryEntrance')">理论演练</button> -->
        <button class="btn" @click="NavJump('/dataBase')"
                :class="$route.path == '/dataBase' ? 'txt-blue' : 'txt-black'">资料库</button>
      </div>
    </div>
    <div class="right-layer">
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="userView">
          <div class="user-photo"><img src="" /></div>
          <div class="user-name"><span>{{ userName }}</span></div>
        </div>
        <el-dropdown-menu class="systemDropdown" slot="dropdown">
          <el-dropdown-item command="user">修改密码</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <button class="btn quitBtn" @click="logout">退出</button>
    </div>

    <!-- 弹窗：修改密码 -->
    <el-dialog title="修改密码" width="7rem" :visible.sync="user.visible" v-dialogDrag>
      <div class="personalCenter">
        <el-form :model="user.form" :rules="user.rules" ref="personalCenterForm" label-width="1.3rem">
          <el-form-item label="原密码：" prop="oldPwd">
            <el-input v-model="user.form.oldPwd" v-inputNE type="password" maxlength="15"></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="newPwd">
            <el-input v-model="user.form.newPwd" v-inputNE type="password" maxlength="15"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码：" prop="newPwd2">
            <el-input v-model="user.form.newPwd2" v-inputNE type="password" maxlength="15"></el-input>
          </el-form-item>
        </el-form>
        <div class="footer-wrap">
          <el-button type="primary" @click="handleEditPassword">确认修改</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import apiUser from "@/api/user";
export default {
  name: 'layout-header',
  data () {
    return {
      userName: '',
      menuNo: 1,//默认选中菜单编号
      user: {
        visible: false,
        form: {
          oldPwd: '',
          newPwd: '',
          newPwd2: ''
        },
        rules: {
          oldPwd: [{
            required: true,
            message: '请输入原密码',
            trigger: 'blur'
          }],
          newPwd: [{
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          }],
          newPwd2: [{
            required: true,
            message: '请二次确认密码',
            trigger: 'blur'
          }]
        }
      }
    }
  },
  computed: {
    projectData () {
      return this.$store.state.global.projectData || {}
    }
  },
  watch: {
    'user.visible' (newVal) {
      if (!newVal) {
        // 初始化个人中心表单
        this.$refs.personalCenterForm.resetFields()
      }
    }
  },
  created () {
    this.userName = JSON.parse(sessionStorage.getItem('userInfo')).f_UserName || '用户'

  },
  methods: {
    NavJump (url) {
      let isCJTY = sessionStorage.getItem('isCJTY') || 0
      //如果在案例里面，点击顶部的菜单，则会二次确认 是否交卷
      if ((this.$route.path == '/case/zhinengkefu' && isCJTY == 0)
        || (this.$route.path == '/case/workflow' && isCJTY == 0)
        || (this.$route.path == '/case/dygpt' && this.$route.query.type == 1)
        || (this.$route.path == '/case/touyanbaogao')) {
        this.$confirm('点击确认将交卷', '提示').then(() => {
          // 调用 交卷接口
          let dygptaccount
          let type = sessionStorage.getItem('casetype')
          if (type == 1) {
            dygptaccount = sessionStorage.getItem('dygptaccount') + '_AL'
          } else if (type == 2) {
            dygptaccount = sessionStorage.getItem('dygptaccount') + '_GZL'
          } else {
            dygptaccount = sessionStorage.getItem('dygptaccount')
          }
          let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
          apiUser.CaseSubmit({
            caseId: sessionStorage.getItem('caseno'),
            studentUsername: dygptaccount,
            userId: userInfo.f_Id,
            mode: type == 1 ? 2 : 1,// 接口中类型标识：1=工作流案例，2=场景类型
          }
          ).then((res) => {
            console.log(res);
            if (res) {
              // this.$message({ type: res.code == 200 ? 'success' : 'warning', message: res.message })

            }
          });
          setTimeout(() => {
            this.$router.replace({
              path: '/case/caseselect'
            })
            // 清除API秘钥缓存
            sessionStorage.removeItem('xlznt_jf_key')
            sessionStorage.removeItem('xlznt_tw_key')
            sessionStorage.removeItem('znkf_key')
          }, 500);
          // this.$router.replace({
          //   path: '/case/caseselect'
          // })
          // // 清除API秘钥缓存
          // sessionStorage.removeItem('xlznt_jf_key')
          // sessionStorage.removeItem('xlznt_tw_key')
          // sessionStorage.removeItem('znkf_key')
        })
      } else {
        this.$router.push({
          path: url
        })
      }

    },
    logout () {
      this.$confirm('点击确定，将退出登录！', '提示').then(() => {
        this.$router.replace({
          path: '/login'
        })
        // 清除所有缓存
        sessionStorage.clear()
        localStorage.clear()
      })
    },

    // 操作下拉菜单
    handleCommand (e) {
      switch (e) {
        case 'user':
          //根据权限来控制是否允许修改密码
          if (!IsAllowEditPassword) {
            this.$alert('无权限修改密码，请联系系统管理员！')
            return
          } else {
            this.user.visible = true
          }
          break
      }
    },

    //点击修改密码
    handleEditPassword () {
      this.$refs.personalCenterForm.validate(valid => {
        if (valid) {
          if (this.user.form.newPwd === this.user.form.newPwd2) {
            this.$confirm('确认要修改密码吗?').then(() => {
              // apiUser.ChangePwd({
              //   oldPwd: this.user.form.oldPwd,
              //   newPwd: this.user.form.newPwd
              // }).then(res => {
              //   this.$message.success('修改成功！')
              //   this.$router.replace({
              //     path: '/login'
              //   })
              // })
            })
          } else {
            this.$message.error('两次密码输入不一致，请确认密码！')
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.topimg {
  // background-image: url("/static/img/top.png");
}

.header-layer {
  color: #fff;
  // background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: var(--headerH);
  // background-color: #21345f;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
  box-sizing: border-box;
  padding: 0 40px;

  .logo-layer {
    display: flex;
    align-items: center;
    cursor: pointer;
    // color: #fff;
    color: #4568f6;
    font-size: 32px;
    letter-spacing: 3px;

    &::before {
      content: "";
      display: inline-block;
      height: 38px;
      width: 38px;
      margin-right: 10px;
      background: url("~@imgs/logo.png") no-repeat center center;
      background-size: contain;
    }
  }

  .center-layer {
    display: flex;
    align-items: center;
    justify-content: center;

    .btn {
      // background-image: linear-gradient(to bottom, #455b8b, #34466d);
      color: #fff;
      height: 26px;
      padding: 0 10px;
      border-radius: 5px;
      font-size: 22px;
      margin-left: 40px;
      text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.1);

      &:hover {
        filter: hue-rotate(8deg) brightness(115%);
      }
    }

    .txt-black {
      color: #fff;
    }

    .txt-blue {
      color: #5574ff;
    }
  }

  .right-layer {
    // margin-left: auto;
    display: flex;
    align-items: center;

    .nav {
      margin-right: 20px;
    }

    .userView {
      position: relative;
      cursor: pointer;
      display: flex;
      align-items: center;

      .user-photo {
        width: 30px;
        height: 30px;
        box-sizing: border-box;
        overflow: hidden;
        background: url('~@imgs/userPhoto.png') no-repeat center center;
        background-size: contain;
        display: inline-block;
        margin-right: 8px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .user-name {
        line-height: 1;
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #fff;
        font-size: 18px;
      }
    }

    .btn {
      // background-image: linear-gradient(to bottom, #4568f6, #000);
      background-color: #4568f6;
      color: #fff;
      height: 26px;
      padding: 0 10px;
      border-radius: 5px;
      font-size: 16px;
      margin-left: 20px;
      text-shadow: 0 0 1px #000;

      &:hover {
        filter: hue-rotate(8deg) brightness(115%);
      }
    }
  }
}
</style>
